import React from 'react';
import { X } from 'lucide-react';
import type { Signal } from '../../features/signals/api/signals';
import { SignalCard } from './SignalCard';

export function SignalDetailModal({ signal, onClose, children }: { signal: Signal; onClose: () => void; children?: React.ReactNode }) {
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" data-testid="signal-detail-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <button
          onClick={onClose}
          data-testid="signal-detail-close"
          className="absolute top-3 right-3 z-10 text-white/70 hover:text-white bg-black/50 rounded-full p-1.5 transition-colors"
        >
          <X className="w-5 h-5" strokeWidth={1.5} />
        </button>
        <SignalCard s={signal}>{children}</SignalCard>
      </div>
    </div>
  );
}
